import { Link, Stack, styled, Typography } from '@mui/material';
import AudioFileOutlinedIcon from '@mui/icons-material/AudioFileOutlined';

export const StyledContainer = styled(Stack)(({ theme }) => ({
  width: '100%',
  padding: theme.spacing(4),
  marginBlock: theme.spacing(1),
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: theme.spacing(1),
  border: '2px dashed',
  borderColor: theme.palette.grey[300],
  gap: theme.spacing(1),
}));

export const StyledAudioFileIcon = styled(AudioFileOutlinedIcon)(
  ({ theme }) => ({
    color: theme.palette.grey[400],
  })
);

export const StyledHintText = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[900],
  fontSize: 16,
  fontWeight: 700,
  lineHeight: 1.67,
}));

export const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.palette.secondary.dark,
  textDecorationColor: theme.palette.secondary.dark,
  '&:hover': {
    cursor: 'pointer',
  },
}));
